module.exports = __webpack_public_path__ + "static/img/公众号.9812032.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公众号.png
// module id = b56q
// module chunks = 1